import { Chip } from '@mui/material';
import {
  ProcurementApprovalStatus,
  ProcurementAvailabilityStatus,
  ProcurementDataQualityStatus,
} from '../../../mocks/data/procurementProductsLensData';

/** Shared status chips for the Procurement Products lens (Demo Mode only) - keeps colour
 * semantics consistent wherever these statuses are surfaced. See
 * src/mocks/data/procurementProductsLensData.ts. */

const AVAILABILITY_COLOR: Record<ProcurementAvailabilityStatus, 'success' | 'error' | 'warning' | 'default'> = {
  [ProcurementAvailabilityStatus.InStock]: 'success',
  [ProcurementAvailabilityStatus.LimitedStock]: 'warning',
  [ProcurementAvailabilityStatus.OutOfStock]: 'error',
  [ProcurementAvailabilityStatus.Discontinued]: 'default',
};

export const AvailabilityChip = ({ status }: { status: ProcurementAvailabilityStatus }) => (
  <Chip label={status}
    size="small"
    color={AVAILABILITY_COLOR[status]} />
);

const APPROVAL_COLOR: Record<ProcurementApprovalStatus, 'success' | 'error' | 'warning' | 'info'> = {
  [ProcurementApprovalStatus.Approved]: 'success',
  [ProcurementApprovalStatus.PendingApproval]: 'warning',
  [ProcurementApprovalStatus.UnderReview]: 'info',
  [ProcurementApprovalStatus.Rejected]: 'error',
};

export const ApprovalStatusChip = ({ status }: { status: ProcurementApprovalStatus }) => (
  <Chip label={status}
    size="small"
    color={APPROVAL_COLOR[status]} />
);

const DATA_QUALITY_COLOR: Record<ProcurementDataQualityStatus, 'success' | 'error' | 'warning'> = {
  [ProcurementDataQualityStatus.Complete]: 'success',
  [ProcurementDataQualityStatus.NeedsReview]: 'warning',
  [ProcurementDataQualityStatus.MissingData]: 'error',
};

export const DataQualityChip = ({ status }: { status: ProcurementDataQualityStatus }) => (
  <Chip label={status}
    size="small"
    color={DATA_QUALITY_COLOR[status]} />
);
